<template>
  <div id="basicInfo">
    <!-- 楼盘 -->
    <div class="header">
      <div class="operation-btns">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="getEstateDailyStatistics"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
        
      </div>
      <div class="filters">
        <el-select
          v-model="query.estateId"
          @change="getEstateDailyStatistics"
          filterable
          remote
          :remote-method="remoteMethod"
          @clear="clear"
          placeholder="请输入楼盘名称"
          class="handle-select"
          clearable
        >
          <el-option
            v-for="item in estates"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button
          class="updown"
          plain
          @click="exportStatistics"
          >导出</el-button
        >
      </div>
    </div>
    <div class="main" ref="main">
      <el-table :data="settingsData" border show-summary :summary-method="getSummaries" @cell-click="cellClick" :max-height="maxHeight">
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="estateName"
          label="楼盘名称"
          min-width="100"
          align="center"
          show-overflow-tooltip
          :resizable="false"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.estateName|nullValue }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reservationCount"
          label="当日报备"
          align="center"
          :resizable="false"
          sortable
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.reservationCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="visitCount"
          label="当日带看"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.visitCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="recognitionCount"
          label="当日认购"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.recognitionCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="netSignCount"
          label="当日网签"
          align="center"
          sortable
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.netSignCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="当日结佣"
          align="center"
          sortable
          prop="commissionCount"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.commissionCount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="当日退订"
          align="center"
          sortable
          prop="refundCount"
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.refundCount }}
            </div>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !settingsData.length">
            列表为空
          </div>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import { dateFormat } from "@/common/filters";
import { deepCopy } from "@/utils/deepCopy";
import { getEstates } from "@/http/api/estate";
import { getEstateDailyStatistics ,getExportEstateDailyStatistics} from "@/http/api/report";
export default {
  data() {
    return {
      daterange: [new Date(new Date(new Date().toLocaleDateString()).getTime()),new Date()],
      query: {
        estateId:'',
        startTime: dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime())),
        endTime: dateFormat(new Date()),
      },
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() >
            new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
                86400 * 1000 -
                1
            )
          );
        },
      },
      settingsData: [],
      maxHeight:0,
      estates:[],
      isLoading: true,
      permissions:{}
    };
  },
  mounted() {
    this.permissions = this.$store.getters.permissions;
    this.getTableHeight();
    this.getEstateDailyStatistics();
  },
  methods: {
    getTableHeight () {
      this.$nextTick(() => {
        const rect = this.$refs.main.getBoundingClientRect()
        this.maxHeight = rect.height;
      })
    },
    cellClick(row, column){
      if (column.label!='当日结佣'&&column.label!='楼盘名称'&&column.label) {
        if (this.permissions["Reservation"]) {
          let query={
            estateId:row.estateId,
            estateName:row.estateName
          }
          switch (column.label) {
            case '当日报备':
              query.flowStatus='reservation'
              break;
            case '当日带看':
              query.flowStatus='visit'
              break;
            case '当日认购':
              query.flowStatus='recognition'
              break;
            case '当日网签':
              query.flowStatus='netSign'
              break;
          }
          if (this.daterange&&this.daterange.length) {
            query.startTime = dateFormat(this.daterange[0]);
            query.endTime = dateFormat(this.daterange[1]);
          }
          let strItem = JSON.stringify(query);
          this.$router.push({
            name:'reservationList',
            params:{
              obj:strItem,
            }
          });
        }else{
          this.$message.warning({
            message: "您暂无查看报备列表权限",
            showClose: true,
          });
        }
      }
    },
    remoteMethod(query){
      if (query) {
        this.filter = query;
        this.getEstates()
      }else{
        this.estates=[];
      }
    },
    clear(){
      this.filter = "";
      this.estates=[];
    },
    getEstates() {
      let query = {
        filter: this.filter,
        condition:'name'
      };
      getEstates(query).then((res) => {
        if (res && res.result) {
          this.estates = res.result.items;
        }
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
       if (column.property == "estateName") {
          sums[index] = "—";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property !== "estateName") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          
          sums[index];
        }
      });
      return sums;
    },
    getEstateDailyStatistics() {
      this.query.startTime = dateFormat(this.daterange[0]);
      this.query.endTime = dateFormat(this.daterange[1]);
      let query = deepCopy(this.query);
      this.settingsData=[];
      this.isLoading = true;
      getEstateDailyStatistics(query).then((res) => {
        if (res.code == 10200) {
          this.settingsData = res.result.items;
        }
        this.isLoading = false;
      }).catch(err=>{
        
          this.isLoading = false;
      });
    },
    exportStatistics() {
      this.query.startTime = dateFormat(this.daterange[0]);
      this.query.endTime = dateFormat(this.daterange[1]);
      let query = deepCopy(this.query);
      // query.skipCount = this.query.skipCount - 1;
      getExportEstateDailyStatistics(query).then(res=>{
        const content = res;
          const blob = new Blob([content]);
          if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = "智能报表-楼盘.xlsx"
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else { // IE10+下载
            navigator.msSaveBlob(blob, "智能报表-楼盘.xlsx")
          }
      })
    }
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#basicInfo {
  .header {
    @include flex(row, center);
    justify-content: space-between;
    margin-bottom: 20px;
    border-radius: $--border-radius-base;
    .operation-btns,
    .filters {
      @include flex(row, center);
      .el-select {
        width: 200px;
        margin-left: 5px;
      }
      .input-with-select {
        width: 400px;
        .el-select {
          width: 110px;
        }
      }
      .updown {
        margin-left: 5px;
      }
    }
  }

  .main{
    height: calc(100vh - 210px);
  }

  .pointer{
    cursor: pointer;
  }
}
</style>
